<!-- ═══ HERO BANNER & STATS ═══ -->
<app-banner />


<!-- ═══ CAMPAIGNS SECTION (LAYOUT FUNDCUBE V.3.0) ═══ -->
<section class="section section-campaigns">
  <div class="container">
    <div class="section-header-row mb-5">
      <div>
        <h2 class="section-title">Campanhas que Inspiram</h2>
        <p class="section-desc">
          Projectos angolanos com maior impacto e momentum nesta semana.
        </p>
      </div>
      <a routerLink="/campanhas" class="btn btn-outline btn-rounded">
        Ver Todas <i class="fas fa-arrow-right ml-2"></i>
      </a>
    </div>

    <!-- ═══ 2 FILTROS PRINCIPAIS: POR NOME (TÍTULO) E POR TIPO DE FINANCIAMENTO ═══ -->
    <div class="home-filters-card mb-4">
      <div class="hfc-row">
        <!-- Filtro 1: Busca por Nome / Título -->
        <div class="hfc-search-box">
          <i class="fas fa-search hfc-search-icon"></i>
          <input
            type="text"
            class="hfc-search-input"
            placeholder="Pesquisar por nome ou título da campanha..."
            [(ngModel)]="searchQuery"
            (input)="onSearchInput()"
            (keydown.enter)="onSearchHome()"
          />
          <button
            *ngIf="searchQuery"
            type="button"
            class="hfc-clear-btn"
            (click)="limparBuscaHome()"
            title="Limpar pesquisa"
          >
            <i class="fas fa-times"></i>
          </button>
          <button
            type="button"
            class="btn btn-primary hfc-search-btn"
            (click)="onSearchHome()"
          >
            <i class="fas fa-search mr-1"></i> Buscar
          </button>
        </div>

        <!-- Filtro 2: Tipo de Financiamento -->
        <div class="hfc-type-filter">
          <span class="hfc-type-label">
            <i class="fas fa-filter text-primary"></i> Modalidade:
          </span>
          <div class="hfc-type-chips">
            <button
              type="button"
              *ngFor="let tipo of tiposFinanciamento"
              class="hfc-type-chip"
              [class.active]="filtroTipoFinanciamento === tipo.id"
              (click)="filtrarPorTipo(tipo.id)"
            >
              <i [class]="tipo.icone"></i>
              <span>{{ tipo.label }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Category Filter Tabs -->
    <div class="cat-tabs" *ngIf="categoriaList?.length">
      <button type="button" class="cat-tab" [class.active]="filtroCategoria === null"
        (click)="filtrarPorCategoria(null)">
        <i class="fas fa-th-large"></i>
        <span>Todas</span>
        <span class="cat-count" *ngIf="totalCampanhasNormais">{{ totalCampanhasNormais }}</span>
      </button>

      <button type="button" class="cat-tab" *ngFor="let cat of categoriaList"
        [class.active]="filtroCategoria === cat.id" (click)="filtrarPorCategoria(cat.id)">
        <i [class]="getCategoryIcon(cat.descricao)"></i>
        <span>{{ cat.descricao }}</span>
        <span class="cat-count" *ngIf="cat.totalCampanhas || cat.quantidadeCampanhas">{{ cat.totalCampanhas ||
          cat.quantidadeCampanhas }}</span>
      </button>
    </div>

    <!-- Loading Skeleton -->
    <ng-container *ngIf="loadingNormais; else SetDataNormais">
      <div class="featured-skeletons-grid">
        <app-skeleton-loader type="card-campanha" [count]="1"></app-skeleton-loader>
        <app-skeleton-loader type="card-campanha" [count]="1"></app-skeleton-loader>
        <app-skeleton-loader type="card-campanha" [count]="1"></app-skeleton-loader>
      </div>
    </ng-container>

    <!-- Campaigns Loaded -->
    <ng-template #SetDataNormais>
      <ng-container *ngIf="normalCampanhas?.length; else noNormalData">
        <app-card-campanha [campanhas]="normalCampanhas"></app-card-campanha>
      </ng-container>

      <ng-template #noNormalData>
        <app-data-void titulo="Nenhuma campanha encontrada nesta categoria"
          descricao="Tente selecionar outra categoria ou explore todas as campanhas disponíveis.">
        </app-data-void>
      </ng-template>
    </ng-template>
  </div>
</section>

<!-- ═══ FEATURED CAMPAIGNS SECTION (LOGO APÓS AS NORMAIS) ═══ -->
<section class="section section-featured">
  <div class="container">
    <div class="section-header-row mb-5">
      <div>
        <div class="section-eyebrow">Em Destaque</div>
        <h2 class="section-title">Campanhas em Destaque</h2>
        <p class="section-desc">
          {{ callToAction || 'Projectos com maior visibilidade e apoio da comunidade angolana nesta semana.' }}
        </p>
      </div>
      <a routerLink="/campanhas" class="btn btn-outline btn-rounded">
        Ver Todas <i class="fas fa-arrow-right ml-2"></i>
      </a>
    </div>

    <!-- Loading Skeleton -->
    <ng-container *ngIf="loading; else SetDataDestaques">
      <div class="featured-skeletons-grid">
        <app-skeleton-loader type="card-campanha" [count]="1"></app-skeleton-loader>
        <app-skeleton-loader type="card-campanha" [count]="1"></app-skeleton-loader>
        <app-skeleton-loader type="card-campanha" [count]="1"></app-skeleton-loader>
      </div>
    </ng-container>

    <!-- Data Loaded -->
    <ng-template #SetDataDestaques>
      <ng-container *ngIf="pagination.data?.length; else noDataDestaques">
        <div class="all_campanhas_container">
          <app-card-destack-campanha [campanhas]="pagination.data"></app-card-destack-campanha>
        </div>
      </ng-container>

      <ng-template #noDataDestaques>
        <app-data-void titulo="Nenhuma campanha em destaque encontrada"
          descricao="Tente novamente mais tarde ou explore todas as categorias."></app-data-void>
      </ng-template>
    </ng-template>
  </div>
</section>

<!-- ═══ HOW IT WORKS ═══ -->
<section class="section section-how" id="como-funciona">
  <div class="container">
    <div class="section-header text-center">
      <div class="section-eyebrow justify-content-center">Como Funciona</div>
      <h2 class="section-title">Simples. Transparente. Angolano.</h2>
      <p class="section-desc mx-auto">
        Três passos para transformar a tua ideia em realidade com o apoio de toda a comunidade angolana.
      </p>
    </div>

    <div class="how-grid">
      <!-- Step 1 -->
      <div class="how-step">
        <div class="how-step-num step1">
          <i class="fas fa-rocket"></i>
        </div>
        <h3 class="how-step-title">Cria a Tua Campanha</h3>
        <p class="how-step-desc">
          Define o teu projecto, estabelece uma meta de financiamento e conta a tua história com clareza e paixão.
        </p>
      </div>

      <!-- Step 2 -->
      <div class="how-step">
        <div class="how-step-num step2">
          <i class="fas fa-bullhorn"></i>
        </div>
        <h3 class="how-step-title">Partilha e Mobiliza</h3>
        <p class="how-step-desc">
          Divulga nas redes sociais e mobiliza apoiadores em todas as 21 províncias através de canais integrados e
          seguros.
        </p>
      </div>

      <!-- Step 3 -->
      <div class="how-step">
        <div class="how-step-num step3">
          <i class="fas fa-hand-holding-dollar"></i>
        </div>
        <h3 class="how-step-title">Recebe os Fundos</h3>
        <p class="how-step-desc">
          Ao atingir a meta, os recursos são transferidos com total conformidade bancária para realizares o teu plano.
        </p>
      </div>
    </div>

    <div class="text-center mt-6">
      <a routerLink="/criar-campanha" class="btn btn-primary btn-xl btn-rounded">
        <i class="fas fa-rocket"></i> Lançar Campanha Agora — É Gratuito
      </a>
    </div>
  </div>
</section>

<!-- ═══ PURPOSE & CATEGORIES ═══ -->
<section class="section section-purpose" id="proposito">
  <div class="container">
    <div class="purpose-wrapper">
      <div class="purpose-intro">
        <div class="section-eyebrow">Nosso Propósito</div>
        <h2 class="section-title">O Que Impulsiona a FundCube?</h2>
        <p class="section-desc">
          Criamos uma ponte directa entre boas ideias e pessoas que querem fazer a diferença em Angola.
        </p>
        <div class="purpose-visual">
          <img src="images/img-purpose.png" alt="Propósito FundCube" class="purpose-art" />
        </div>
      </div>

      <div class="purpose-list">
        <div class="purpose-card" *ngFor="let item of purposes">
          <div class="purpose-icon-box" [ngClass]="item.colorClass">
            <i [class]="item.faIcon"></i>
          </div>
          <div class="purpose-info">
            <h4 class="purpose-card-title">{{ item.tittle }}</h4>
            <p class="purpose-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ═══ TESTIMONIALS / EXPERIÊNCIAS ═══ -->
<!-- <section class="section section-testimonials">
  <div class="container">
    <div class="section-header text-center">
      <div class="section-eyebrow justify-content-center">Histórias Reais</div>
      <h2 class="section-title">Experiências que Nos Movem</h2>
      <p class="section-desc mx-auto">
        Conheça quem já realizou campanhas ou apoiou projectos de impacto na nossa plataforma.
      </p>
    </div>

    <div class="testimonials-grid" *ngIf="loadingTestemunhos">
      <div class="testimonial-card skeleton-card" *ngFor="let _ of [1, 2, 3]">
        <div class="testimonial-stars opacity-50">
          <i class="fas fa-star text-slate-300" *ngFor="let _ of [1,2,3,4,5]"></i>
        </div>
        <p class="testimonial-text text-slate-400">A carregar depoimento...</p>
        <div class="testimonial-author">
          <div class="testimonial-avatar-initials opacity-40">--</div>
          <div>
            <div class="testimonial-name text-slate-400">A carregar...</div>
            <div class="testimonial-role text-slate-300">FundCube</div>
          </div>
        </div>
      </div>
    </div>

    <div class="testimonials-grid" *ngIf="!loadingTestemunhos && testemunhos.length > 0">
      <div class="testimonial-card" *ngFor="let item of testemunhos">
        <div class="testimonial-stars">
          <i class="fas fa-star star-filled" *ngFor="let _ of getStarsArray(item.estrelas)"></i>
          <i class="far fa-star star-empty" *ngFor="let _ of getEmptyStarsArray(item.estrelas)"></i>
        </div>
        <p class="testimonial-text">"{{ item.descricao }}"</p>
        <div class="testimonial-author">
          <div class="testimonial-avatar-initials">
            {{ getUserInitials(item.utilizadorNome || item.utilizadorNomeAnonimo) }}
          </div>
          <div>
            <div class="testimonial-name">{{ item.utilizadorNome || item.utilizadorNomeAnonimo || 'Utilizador FundCube'
              }}</div>
            <div class="testimonial-role" *ngIf="item.dataCriacao">
              {{ item.dataCriacao | date:'dd MMM yyyy' }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="testimonials-grid" *ngIf="!loadingTestemunhos && testemunhos.length === 0">
      <div class="testimonial-card" *ngFor="let item of ExperienceUsers">
        <div class="testimonial-stars">
          <i class="fas fa-star star-filled"></i>
          <i class="fas fa-star star-filled"></i>
          <i class="fas fa-star star-filled"></i>
          <i class="fas fa-star star-filled"></i>
          <i class="fas fa-star star-filled"></i>
        </div>
        <p class="testimonial-text">"{{ item.description }}"</p>
        <div class="testimonial-author">
          <img [src]="item.img" [alt]="item.name" class="testimonial-avatar" />
          <div>
            <div class="testimonial-name">{{ item.name }}</div>
            <div class="testimonial-role">{{ item.location }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->

<!-- ═══ CTA BANNER ═══ -->
<section class="section section-cta">
  <div class="container">
    <div class="cta-banner">
      <div class="cta-banner-content">
        <div class="section-eyebrow text-white mb-2" style="color: rgba(255,255,255,0.85);">Comece Hoje</div>
        <h2 class="cta-banner-title">A Angola que queremos começa aqui.</h2>
        <p class="cta-banner-desc">
          Junta-te a milhares de angolanos que já estão a transformar ideias em impacto social e económico.
        </p>
      </div>
      <div class="cta-banner-actions">
        <a routerLink="/criar-campanha" class="btn btn-amber btn-xl btn-rounded">
          <i class="fas fa-rocket"></i> Lançar Campanha
        </a>
        <a routerLink="/campanhas" class="btn btn-white btn-xl btn-rounded">
          <i class="fas fa-compass"></i> Explorar Projectos
        </a>
      </div>
    </div>
  </div>
</section>

<!-- ═══ PARTNERS & NEWSLETTER ═══ -->
<app-partners />
<app-newsletter />